import React from "react";
import { Link } from "react-router-dom";

import focusFeature from "../../assets/focus_2.png";
import focusMap from "../../assets/focus_3.png";
import "../../assets/bdcFocus.css";

const BdcFocus = ({ project }) => {
  const liveLink =
    (project?.links && project.links[0]) || "https://focus.bronxdoc.org/";

  return (
    <div className="bdcFocus">
      <div className="page">
        <div className="topbar">
          <span className="proj">BDC — Focus</span>
          <Link className="close" to="/">
            Close
          </Link>
        </div>

        <header className="head">
          <div>
            <p className="kicker">Community Newspaper</p>
            <h1 className="headline">
              A publishing home for the Bronx Documentary Center's student
              storytellers.
            </h1>
          </div>
          <aside className="info">
            <div className="row">
              <span className="k">Role</span>
              <span className="v">Developer &amp; UX Designer</span>
            </div>
            <div className="row">
              <span className="k">Year</span>
              <span className="v">2025 – Present</span>
            </div>
            <div className="row">
              <span className="k">Link</span>
              <a
                className="v link"
                href={liveLink}
                target="_blank"
                rel="noreferrer"
              >
                Live Site →
              </a>
            </div>
          </aside>
        </header>

        <figure className="lead-fig">
          <div
            className="shot lead placeholder"
            role="img"
            aria-label="Lead screenshot placeholder"
          >
            <span>Lead screenshot — to be added</span>
          </div>
          <figcaption className="cap">
            <span className="n">01</span>
            <span className="t">Homepage</span>
          </figcaption>
        </figure>

        <div className="prose">
          <div>
            <p className="lbl">About</p>
            <p>
              BDC Focus is the community newspaper for the Bronx Documentary
              Center's Youth Photo Leage (ages 11-18). It is an expansion of
              their printed publication, enabling students to learn digital
              storytelling skills.
            </p>
          </div>
          <div>
            <p className="lbl">My Role</p>
            <p>
              I designed and built the publishing experience: the editorial
              layout system, the homepage and article templates, and interactive
              map-based stories. I worked with students and staff to keep it
              simple enough for them to run on their own while still allowing
              space for collaboration with developers on more complex features.
            </p>
          </div>
        </div>

        <div className="gallery">
          <figure>
            <img
              className="shot gallery-img"
              src={focusFeature}
              alt="BDC Focus feature documentary story page"
            />
            <figcaption className="cap">
              <span className="n">02</span>
              <span className="t">
                Feature story about the community surrounding a skate park in
                the Bronx
              </span>
            </figcaption>
          </figure>
          <figure>
            <img
              className="shot gallery-img"
              src={focusMap}
              alt="BDC Focus interactive map story on Bronx smoke shops"
            />
            <figcaption className="cap">
              <span className="n">03</span>
              <span className="t">
                Interactive map story about smoke shops in the Bronx
              </span>
            </figcaption>
          </figure>
        </div>
      </div>
    </div>
  );
};

export default BdcFocus;
